// Angular
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

// Libraries
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { takeUntil } from 'rxjs';
// Models
import { AppCleanup } from '../../../../shared/models';
import { Job } from '../../models/job.model';

// Services
import { JobService } from '../../services/job.service';
import { Timezone } from '../../services/timezone.service';

// Environment
import { environment } from '../../../../../environments/environment';

@Component({
	selector: 'job-multi-stream-dialog',
	templateUrl: './job-multi-stream-dialog.component.html',
	styleUrls: ['./job-multi-stream-dialog.component.scss'],
})
export class JobMultiStreamDialogComponent extends AppCleanup implements OnInit, OnDestroy {
	componentTitle: string = 'Job Multistream';
	form: FormGroup;
	jobsToStreamTo: Job[];
	enableJobMultiStream: boolean = false;
	timezones: Timezone[];

	constructor(
		private formBuilder: FormBuilder,
		private jobService: JobService,
		public dialogRef: MatDialogRef<JobMultiStreamDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { job: Job }
	) {
		super();
		this.enableJobMultiStream = environment.lvEnableJobMultiStream;
	}

	ngOnInit() {
		if (this.enableJobMultiStream && this.data.job.unitPeriods.length === 1) {
			this.jobService
				.getJobsToStreamTo(this.data.job.unitPeriods[0]?.id)
				.pipe(takeUntil(this.destroy))
				.subscribe((jobs) => {
					this.jobsToStreamTo = [];

					jobs.forEach((j) => {
						this.jobsToStreamTo.push(new Job(j));
					});

					this.buildJobChooseForm();
				});
		} else {
			// Uncomment when ready for multi-stream
			this.buildJobChooseForm();
		}
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	buildJobChooseForm() {
		this.form = this.formBuilder.group({
			streamToExistingJob: [true],
			jobToStreamToId: [null, Validators.required],
		});
	}

	submit() {
		if (this.form && this.form.valid) {
			let jobData = {
				action: 'job-choose',
				jobToStreamToId: this.form.controls.jobToStreamToId.value,
				unitPeriodId: this.data.job.unitPeriods[0]?.id,
			};

			this.dialogRef.close({
				jobData: jobData,
			});
		}
	}

	getDisableSubmit() {
		return this.form && !this.form.valid;
	}
}
